import React from 'react';

function Hero() {
  return (
    <div className="bg-[url('/bg-hero-results-1.png')] bg-cover bg-no-repeat w-[256px] h-[150px] absolute left-2/4 ml-[-128px] z-[-1] md:z-0 md:w-[575px] md:h-[326px] md:ml-[-287px]" />
  );
}

export default Hero;
